import React from 'react'
import Top from './Top'
import './Footer.css'
import Botom from './Botom'

const Footer = () => {
  return (
    <div>
        <Top/>
        <Botom/>
    </div>
  )
}

export default Footer